import { useAppConfig } from '../api/JsdhNotifikaceService/service/AdminMutations';
import { isMockActive } from '../utils/isMockActive';

/**
 * Feature flagy (HO-88, epic HO-84) — čtení resolvovaných flagů z app-config.
 *
 * Sémantika (fail-closed): loading / chyba před prvním načtením / chybějící pole
 * features (BE bez HO-87) / neznámý klíč => false. Mock režim (?mock=) => vše true
 * a žádné BE volání (useAppConfig má enabled: !isMockActive()).
 *
 * Flag gateuje POUZE viditelnost UI (D1) — bezpečnostní hranicí zůstávají role
 * na BE (D2). N volání hooku = 1 HTTP request (sdílený queryKey ['appConfig'],
 * staleTime 5 min). POZOR: /api/konfigurace/app-config je authenticated —
 * nepoužívat na veřejných stránkách (/, /poplach, /odpoved).
 */

export interface UseFeatureFlagsResult {
    /** Resolvovaný stav flagu — fail-closed (viz výše). */
    isFeatureEnabled: (key: string) => boolean;
    /** True jen během prvního načítání app-config (mimo mock režim). */
    isLoading: boolean;
}

export interface UseFeatureFlagResult {
    enabled: boolean;
    isLoading: boolean;
}

export const useFeatureFlags = (): UseFeatureFlagsResult => {
    const { data, isLoading } = useAppConfig();

    if (isMockActive()) {
        // ?mock= preview: všechny flagy zapnuté, aby fail-closed neschoval flag-gated UI.
        return { isFeatureEnabled: () => true, isLoading: false };
    }

    const features = data?.features;
    return {
        isFeatureEnabled: (key: string) => features?.[key] === true,
        isLoading,
    };
};

export const useFeatureFlag = (key: string): UseFeatureFlagResult => {
    const { isFeatureEnabled, isLoading } = useFeatureFlags();
    return { enabled: isFeatureEnabled(key), isLoading };
};
